import { render } from "./Submit.vue?vue&type=template&id=430522a7"
import script from "./Submit.vue?vue&type=script&lang=js"
export * from "./Submit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__